var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_60597",
    "data-name": "Group 60597",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.77,
    height: 21.77,
    viewBox: "0 0 21.77 21.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_159884",
    "data-name": "Path 159884",
    d: "M27.285,16.4A10.885,10.885,0,1,0,38.17,27.285,10.9,10.9,0,0,0,27.285,16.4Zm0,20.238a9.353,9.353,0,1,1,9.353-9.353,9.366,9.366,0,0,1-9.353,9.353Z",
    transform: "translate(-16.4 -16.4)",
    fill: "#c44c36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_159885",
    "data-name": "Path 159885",
    d: "M44.816,47.8H33.282a.923.923,0,0,0,0,1.843H44.816a.923.923,0,0,0,0-1.843Z",
    transform: "translate(-28.164 -37.933)",
    fill: "#c44c36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.b89173f1b859f894c0530aae971a7d0f.svg";
export { ForwardRef as ReactComponent };